























import Vue from "vue";
import StandartCard from "@/components/Card/StandartCard/StandartCard.vue";
import { MainStateEnum } from "@/types/types";
import { store } from "@/store/store";

export default Vue.extend({
  name: "OnlineCard",
  components: { StandartCard },
  computed: {
    displayPosedDevices(): string {
      let devices_onlines = 0;
      store.getters.DEVICE_ALL_ID.forEach((device_id) => {
        let device_state: string = store.getters.DEVICE_BY_ID[device_id].state;
        let main_state_id: string = store.getters.STATE_BY_ID[device_state].main_state;
        let main_state_name: string = store.getters.MAIN_STATE_BY_ID[main_state_id].name;
        if (main_state_name === MainStateEnum.TERRAIN) devices_onlines += 1;
      });
      return devices_onlines.toString();
    },
    displayTotalDevices(): string {
      return store.getters.DEVICE_ALL_ID.length.toString();
    }
  }
});
